import { Injectable } from '@angular/core';

import { SearchableAlphabets, SearchableAlphabetsPa } from '../core/constants';
import * as parse5 from 'parse5';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  getVerticalScrollPercentage(elm: any) {
    const p = elm.parentNode;
    return (
      ((elm.scrollTop || p.scrollTop) / (p.scrollHeight - p.clientHeight)) * 100
    );
  }

  stripHTML(html: string) {
    const doc = parse5.parse(html);
    // console.log(doc)
    return this.getTextContent(doc) || '';
  }

  private getTextContent(node: any): string {
    if (node.nodeName === '#text') {
      return node.value;
    }

    let textContent = '';
    if (node.childNodes) {
      for (const childNode of node.childNodes) {
        textContent += this.getTextContent(childNode);
      }
    }

    return textContent;
  }


  showSmallerString(descriptionText: string) {
    if (descriptionText) {
      let text = this.stripHTML(descriptionText);
      let result = text.substring(0, 152).lastIndexOf(" ");
      return text.substring(0, result);
    } else {
      return descriptionText;
    }
  }

  showSmallerIntroductionString(descriptionText: string | undefined) {
    if (descriptionText) {
      let text = this.stripHTML(descriptionText);
      let result = text.substring(0, 750);
      return result;
    } else {
      return descriptionText;
    }
  }

  showSmallerTermString(descriptionText: string | undefined) {
    if (descriptionText) {
      let text = this.stripHTML(descriptionText);
      let result = text.substring(0, 300);
      return result;
    } else {
      return descriptionText;
    }
  }

  /**
   * remove html from the passed string
   * calculate the length of the text
   * used in the methods to decide if we should show (...) or not
   * @param text string
   * @returns number (of characters in the string)
   */
  calculateTextLength(text: string | undefined): number {
    if (text) {
      let textWihoutHTML = this.stripHTML(text);
      return textWihoutHTML.length;
    } else {
      return 0;
    }
  }

  fetchImageThumbnail(imageUrl: string) {
    const pattern =
      /(?:watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/|youtube\.com\/watch\?v=)([^&?/]+)/;

    // Match the pattern against the image URL
    const match = imageUrl.match(pattern);

    // Extract the video ID from the matched result
    const videoId = match && match[1];

    // Put the video ID in the thumbnail link and return
    // `https://i3.ytimg.com/vi/${videoId}/hqdefault.jpg` maxresdefault
    return `https://i3.ytimg.com/vi/${videoId}/hqdefault.jpg`;
  }

  createUnavailableCharsArrayFromProperty(
    propName: string,
    arrayOfObjects: any
  ) {
    let arrayOfAvailableAlphabets: any = [];
    for (let prop in arrayOfObjects) {
      let wordString = arrayOfObjects[prop][propName];
      let firstChar = Array.from(wordString)[0];
      if (arrayOfAvailableAlphabets.indexOf(firstChar) === -1) {
        arrayOfAvailableAlphabets.push(firstChar);
      }
    }
    const language = localStorage.getItem('language');
    let allAlphabetsArray: any = [];
    if(language === 'en'){
    allAlphabetsArray = SearchableAlphabets;
    }
    else{
    allAlphabetsArray = SearchableAlphabetsPa;
    }

    let unavailableCharsArray: any = [];
    unavailableCharsArray = allAlphabetsArray.filter((alphabet: any) => {
      if (
        alphabet.length === 1 &&
        arrayOfAvailableAlphabets.indexOf(alphabet) === -1
      ) {
        return alphabet;
      } else {
        return false;
      }
    });

    return unavailableCharsArray;
  }

  convertString(preString: string): string {
    let x = 0;
    let y = 0;
    let c = '';
    let postXIncrement = 0;

    // Step 1: Normalize <bani: ...> by replacing spaces with underscores
    const postStringTT = preString.replace(
      /(<bani:\s*.*?\s*&\s*section:\s*.*?\s*&\s*footnote:\s*\d+>)/g,
      (match) => ` ${match.replace(/\s/g, '_')} `
    );

    // Step 2: Tokenize and wrap content
    let postString = postStringTT.replace(
      /<[^>]+>|&nbsp;|<br>| {3}| {2}| |\S+/g,
      (match, index, source) => {
        // Reset on line break
        if (match === '<br>') {
          postXIncrement = 0;
          x = 0;
          y++;
          return match;
        }

        // Restore bani tag spaces
        if (match.includes('<bani:')) {
          return match.replace(/_/g, ' ');
        }

        // Keep HTML tags and nbsp unchanged
        if (/<[^>]+>|&nbsp;/.test(match)) {
          return match;
        }

        // Increment x for visible tokens
        if (match.trim()) {
          
          x = postXIncrement;
          postXIncrement === 0 ? postXIncrement += (match.length) : postXIncrement += match.length;

        } else if (match === ' ' || match === '  ' || match === '   ') {
          x = postXIncrement;
          if (x != 0) postXIncrement++;
        }

        const nextChars = source.substring(
          index,
          index + match.length + 3
        );

        // Triple space
        if (nextChars === match + '   ') {
          if (match === ' ') {
            c = 'empty';
          }
          postXIncrement++;
          postXIncrement++;
          return (
            `<span v class="dictionary-word ${c}${match}" x=${x} y=${y}>` +
            match +
            '&nbsp;&nbsp;</span>'
          );
        }

        // Double space
        if (nextChars.startsWith(match + '  ')) {
          if (match === ' ') {
            c = 'empty';
          }
          postXIncrement++;
          return (
            `<span v class="dictionary-word ${c}${match}" x=${x} y=${y}>` +
            match +
            '&nbsp;</span>'
          );
        }

        // Default
        return (
          `<span j class="dictionary-word" x=${x} y=${y}>` +
          match +
          '</span>'
        );
      }
    );

    // Step 3: Replace normal space after span with &nbsp;
    postString = postString.replace(/<\/span> /g, '</span>&nbsp;');

    return postString;
  }
  
  wrapWordsInSpanTags(paragraph: string) {
    var modifiedParagraph = paragraph.replace(
      /(<\/?[^>]+>)/g,
      function (match: any) {
        // Check if the match is an HTML tag
        if (/<\/?[^>]+>/.test(match)) {
          return match;
          // Return the tag as it is
        } else {
          // Split the non-tag portion into individual words
          var words = match.split(/\s+/);
          // Wrap each word in a <span> tag
          var wrappedWords = words.map(function (word: string) {
            return '<span class="dictionary-word">' + word + '</span>';
          }); // Join the wrapped words back together
          return wrappedWords.join(' ');
        }
      }
    );
    return modifiedParagraph;
  }
}

